export const PROFILE = {
  name: "Naresh Gabriel",
  first: "Naresh",
  last: "Gabriel",
  titleLines: ["Operations", "Business Growth", "Commercial Leadership"],
  location: "Perth, Western Australia",
  intro:
    "Commercially focused senior executive with more than 15 years leading operations, business growth, commercial strategy and organisational performance across renewable energy, agriculture, professional services, financial services and international business.",
  headshot: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/e0fd81c51de87afdb752aecc58649e2f6bcacce15ad74bb9bd7f0c449d58c501.jpeg",
  portrait: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/6f2eb480ae7f8cafcf361fecd66678625a719b6249b3f1028d833d91709afa8e.jpeg",
  energy: "https://images.pexels.com/photos/7115487/pexels-photo-7115487.jpeg",
  architecture: "https://images.unsplash.com/photo-1526289034009-0240ddb68ce3",
};

export const ABOUT = [
  "Recognised for partnering with business owners to improve operational performance, commercial capability and long-term growth. Proven ability to build businesses, implement systems and processes, develop high-performing teams and establish strategic partnerships that deliver measurable commercial outcomes.",
  "Experienced working with executive stakeholders, government agencies, multinational organisations and private investors to deliver complex projects, operational improvements and sustainable business growth.",
  "A hands-on leader who combines strategic thinking with practical execution, strong financial discipline and an unwavering focus on accountability, continuous improvement and customer outcomes.",
];

export const STATS = [
  { value: "US$180M+", label: "Renewable project pipeline directed", span: "lg:col-span-7" },
  { value: "US$750M", label: "Marine & yachting assets managed", span: "lg:col-span-5" },
  { value: "US$40M", label: "Bioethanol proof-of-concept negotiation", span: "lg:col-span-4" },
  { value: "$500K", label: "Annual revenue built for legal firm", span: "lg:col-span-4" },
  { value: "SGD 1.6M", label: "Annual revenue across Southeast Asia", span: "lg:col-span-4" },
  { value: "40+", label: "Employees, contractors & consultants led", span: "lg:col-span-4" },
  { value: "~60", label: "SME client relationships at Commonwealth Bank", span: "lg:col-span-4" },
  { value: "15+ yrs", label: "Executive leadership across five sectors", span: "lg:col-span-4" },
];

export const CAPABILITIES = [
  "General Management", "Operational Leadership", "Business Growth", "Commercial Management",
  "Strategic Planning", "Business Transformation", "Financial Performance", "Budget Management",
  "Operational Excellence", "Continuous Improvement", "Leadership Development", "Stakeholder Management",
  "Contract Negotiation", "Business Development", "Governance & Compliance", "Risk Management",
  "Change Management", "Team Leadership", "Customer Experience", "Strategic Partnerships",
];

export const EXPERIENCE = [
  {
    role: "Managing Director",
    company: "RAI Energy Pty Ltd",
    place: "Perth",
    period: "2020 — Present",
    summary:
      "Founder and Managing Director of an Australian renewable energy and agriculture business responsible for strategy, commercial development, operations and stakeholder engagement.",
    achievements: [
      "Directed commercial development of an estimated US$180 million project pipeline.",
      "Led negotiations relating to a proposed US$40 million commercial bioethanol proof-of-concept project.",
      "Built strategic partnerships across Australia, Japan, Singapore, Vietnam and China.",
      "Worked closely with CSIRO, DPIRD, Austrade and industry stakeholders to support project delivery.",
      "Developed integrated agricultural supply chains supporting renewable fuel production.",
      "Established operational processes supporting business scalability and long-term growth.",
    ],
  },
  {
    role: "Director of Operations & Co-owner",
    company: "Family Law Practice",
    place: "",
    period: "2020 — 2024",
    summary:
      "Worked alongside the owners to oversee business operations, commercial performance and organisational growth within a multidisciplinary legal practice.",
    achievements: [
      "Helped grow the business to approximately $500,000 annual revenue.",
      "Led a team of seven staff while improving operational performance and accountability.",
      "Introduced operational systems and business improvements supporting sustainable growth.",
      "Built strategic referral partnerships across accounting, finance, real estate, business advisory and wellness sectors.",
      "Improved client experience and strengthened long-term customer relationships.",
    ],
  },
  {
    role: "Business Banking Specialist",
    company: "Commonwealth Bank of Australia",
    place: "",
    period: "2017 — 2019",
    summary:
      "Managed a portfolio of SME clients, providing commercial lending, financial solutions and strategic business advice.",
    achievements: [
      "Managed relationships with approximately 60 SME businesses.",
      "Assisted clients with commercial finance, business growth and operational funding.",
      "Built trusted long-term client relationships through proactive engagement.",
      "Worked collaboratively with specialist teams to deliver tailored business solutions.",
    ],
  },
  {
    role: "Vice President — Business Development",
    company: "Marsh & McLennan",
    place: "Southeast Asia",
    period: "2012 — 2016",
    summary:
      "Led business development activities throughout Southeast Asia, building strategic client relationships across energy, infrastructure and commercial sectors.",
    achievements: [
      "Generated approximately SGD1.6 million in annual business revenue.",
      "Developed relationships with multinational organisations and executive decision-makers.",
      "Negotiated commercial opportunities across multiple international markets.",
      "Supported growth through strategic partnerships and consultative business development.",
    ],
  },
  {
    role: "Yacht Finance, Insurance & Transportation",
    company: "Prestige Financial Group",
    place: "Singapore",
    period: "2008 — 2012",
    summary:
      "Worked within Singapore's marine and yachting lifestyle sector, delivering yacht financing, insurance and transportation solutions to high-net-worth clients, owners and international buyers.",
    achievements: [
      "Managed a portfolio of approximately US$750 million in assets across the marine and yachting sector.",
      "Generated approximately US$15 million in revenue through finance, insurance and transportation solutions.",
      "Structured yacht finance and insurance solutions for high-net-worth individuals and marine businesses.",
      "Developed a yachting program across the Riau Islands, enabling yacht owners to sail to and enjoy barefoot luxury.",
      "Coordinated yacht transportation, logistics and cross-border delivery arrangements.",
      "Built a trusted network of owners, brokers, insurers and marine service providers across Asia.",
    ],
  },
];

export const TARGET_INDUSTRIES = [
  { name: "Property Development", note: "Site acquisition, project management, capital partnerships and end-to-end delivery." },
  { name: "Skincare & Beauty", note: "Managing operations and business development to grow brands into market leaders." },
  { name: "Yachting & Marine", note: "Developing yachting and boating memberships and destination sailing programs." },
  { name: "Luxury & Lifestyle", note: "Premium positioning, experiential retail and global market entry." },
];

export const STRENGTHS = [
  { title: "Operational Performance", text: "Leading operational performance across growing businesses and partnering directly with owners to drive strategy and execution." },
  { title: "Scalable Systems", text: "Developing scalable systems, governance and reporting frameworks that let businesses grow without losing control." },
  { title: "High-Performing Teams", text: "Building high-performing teams and accountability cultures that consistently deliver measurable outcomes." },
  { title: "Commercial Growth", text: "Delivering commercial growth through strategic partnerships, negotiation and disciplined business development." },
  { title: "Financial Discipline", text: "Managing budgets, commercial negotiations and organisational performance with strong financial discipline." },
  { title: "Trusted Relationships", text: "Building trusted relationships with clients, suppliers, investors and government stakeholders across Australia and Asia." },
];

export const INDUSTRIES = [
  "Renewable Energy", "Agriculture", "Professional Services",
  "Financial Services", "International Business", "Commercial Strategy",
];

export const COMPETENCIES = [
  "Microsoft Office Suite", "CRM Systems", "Business Planning", "Financial Reporting",
  "Budget Management", "Project Management", "Risk & Compliance", "Strategic Planning",
  "Commercial Negotiation", "Process Improvement",
];

export const EDUCATION = [
  { title: "Diploma in Finance & Insurance", school: "Singapore College of Insurance" },
  { title: "Diploma in Business Administration", school: "Singapore College of Insurance" },
];

export const LINKS = {
  linkedin: "https://www.linkedin.com/in/nicholasgabriel-bcn/",
  website: "https://raienergy.com.au",
  youtube: "https://www.youtube.com/watch?v=UQfzoCxz6tM&t=22s",
  press: "https://thewest.com.au/business/finance/wa-investors-bullish-on-crypto-despite-bitcoin-slump--c-4832237",
};

export const GALLERY_CATEGORIES = [
  "All",
  "Biofuels & Agriculture",
  "Property & Development",
  "Luxury",
  "Leadership & Events",
  "Marine & Yachting",
];

export const GALLERY = [
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/aab63bcd016fc1327e514159388ca9d589ac4fcfb1a03d57c5c84539b167aebc.jpeg", title: "In the sorghum fields", category: "Biofuels & Agriculture" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/6206784db75d5ff0d4ca819ebecdc099f0f9990b56aa30aeb5a11d9b7f0c65ad.jpeg", title: "Sorghum to biofuel", category: "Biofuels & Agriculture" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/e854b491e4faf3607257b28f6b8543b93de8e48cc8a0ff67720aee4014a51755.jpeg", title: "Development vision", category: "Property & Development" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/0fe2e27702a45c239667bedef185ee82abe6fbb9adc42eaa4e16ed41c7419cad.jpeg", title: "Luxury living", category: "Luxury" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/51979a986285d9d5f9dcf87a18b6f66853dc6c73c4bed9be686cb202373772ee.jpeg", title: "In the field", category: "Biofuels & Agriculture" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/6227aaa4542136cd406866ce68e385f85ed52a78e618ec67e3ccfc4ca61055ef.jpeg", title: "On-site development", category: "Property & Development" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/40d913473756016190ea7876fc64e8d6f5915d20e4c61dd5289984c8fbd536c1.jpeg", title: "Brand & retail", category: "Luxury" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/38c2526558527f4a5e042280896e053b5862a17c270323c2c5926657efd9d355.jpeg", title: "Leading the boardroom", category: "Leadership & Events" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/0cab88245e3130d6cabd30f9b9aab5e0cefb2272e80e22a9070708c71cbc087c.jpeg", title: "Closing the deal", category: "Leadership & Events" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/3a7291669a88a45eeb2a470c0d1c10d83eafc8c0d2e223c5751d335a9fad6aac.jpeg", title: "On deck", category: "Marine & Yachting" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/1c0ba747b3cd5257ee41c4e98ce62c6807b7769c518b1a51e347b33d200f889f.jpeg", title: "On stage", category: "Leadership & Events" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/e37c0febd2d9eded7a90530d95a81ead1da84edd92d46d13d1c56c71d9d2164c.jpeg", title: "At the marina", category: "Marine & Yachting" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/491ba4b48ab66bd46b557e64c549e5fae41c20d569de58d2d5aed243d39ff625.jpeg", title: "Industry networking", category: "Leadership & Events" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/0f988b81f0ee3959fef9013135cd93048f258aa99449462cbcdd8d93210ddf2c.jpeg", title: "At work", category: "Leadership & Events" },
  { url: "https://static.prod-images.emergentagent.com/jobs/9f9ff7eb-25db-474e-a720-fd53ee3b20a9/images/ce57dc7a78e9d3099ef5e36fc97d3462114cefab36cbba799cfb1628f4b53d98.jpeg", title: "Signing partnerships", category: "Leadership & Events" },
];
